// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"559":"game-detail-page","567":"main-layout","962":"home"}[chunkId] + "." + {"559":"5c350ba5","567":"e8b2476f","962":"f84555ce"}[chunkId] + ".js";
};